import { useState } from 'react';

export const useMarkerStore = () => {
    const [pins, setPins] = useState([]);
    const [currentPin, setCurrentPin] = useState(null);
    const [tmpPin, setTmpPin] = useState(null);

    const clearCurrentPin = () => setCurrentPin(null);
    const clearTmpPin = () => setTmpPin(null);

    return {
        pins,
        setPins,
        currentPin,
        setCurrentPin,
        clearCurrentPin,
        tmpPin,
        setTmpPin,
        clearTmpPin
    };
};